import { usePageContext } from '@hero/web-context';
import { CustomTrigger } from '../Sidebar/CustomTriggerSidebar';
import { UserProfileMenu } from '../../feature/User/ProfileMenu';

interface TopBarProps {
  isCollapsed: boolean;
  /** Passed to sidebar trigger so it works when context is unavailable (e.g. during HMR). */
  onToggleSidebar?: () => void;
  /** Optional slot for persistent action buttons (e.g. "Create Order"). */
  actions?: React.ReactNode;
}

export default function TopBar({ isCollapsed, onToggleSidebar, actions }: TopBarProps) {
  const { pageName } = usePageContext();

  return (
    <>
      <div className="flex gap-3 md:gap-0">
        <div className="block md:hidden">
          <CustomTrigger
            isCollapsed={isCollapsed}
            className="border-[1.5px] rounded-lg p-2"
            toggleSidebar={onToggleSidebar}
          />
        </div>
        <h1 className="text-[18px] sm:text-[24px] leading-[36px] font-[500] text-black">
          {pageName}
        </h1>
      </div>

      <div className="flex items-center gap-4">
        {actions}
        <UserProfileMenu />
      </div>
    </>
  );
}
